// Reusable FLEXX logo that strips the baked-in black background at the pixel
// level (canvas-based) so it renders cleanly on any surface.
import React, { useEffect, useState } from "react";

const SRC = "/flexx-logo.png";
let cachedDataUrl = null;
let cachedPromise = null;

function loadTransparentLogo() {
  if (cachedDataUrl) return Promise.resolve(cachedDataUrl);
  if (cachedPromise) return cachedPromise;
  cachedPromise = new Promise((resolve) => {
    const img = new Image();
    // IMPORTANT: do NOT set crossOrigin="anonymous" — same-origin asset, and
    // adding it breaks PWA service-worker cached responses without CORS headers.
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth || 400;
        canvas.height = img.naturalHeight || 400;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const pix = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const d = pix.data;
        for (let i = 0; i < d.length; i += 4) {
          const lum = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
          if (lum < 42) {
            d[i + 3] = 0;                                    // pure black -> transparent
          } else if (lum < 95) {
            d[i + 3] = Math.floor(d[i + 3] * ((lum - 42) / 53)); // dark grays -> fade
          }
        }
        ctx.putImageData(pix, 0, 0);
        cachedDataUrl = canvas.toDataURL("image/png");
        resolve(cachedDataUrl);
      } catch (e) { resolve(null); }
    };
    img.onerror = () => resolve(null);
    img.src = SRC;
  });
  return cachedPromise;
}

export default function FlexxLogoImg({ style, alt = "FLEXX", ...rest }) {
  const [dataUrl, setDataUrl] = useState(cachedDataUrl);
  useEffect(() => {
    if (cachedDataUrl) return;
    let cancelled = false;
    loadTransparentLogo().then((url) => { if (!cancelled && url) setDataUrl(url); });
    return () => { cancelled = true; };
  }, []);
  return (
    <img
      src={dataUrl || SRC}
      alt={alt}
      style={style}
      onError={(e) => { e.target.style.display = "none"; }}
      {...rest}
    />
  );
}
